import Fetch, { V1, V2, V3, V5, clearSession } from 'Util/fetcher';

const ON_REQUEST_AUTH = 'ON_REQUEST_AUTH';
const ON_REQUEST_AUTH_FAILURE = 'ON_REQUEST_AUTH_FAILURE';
const ON_REQUEST_AUTH_SUCCESS = 'ON_REQUEST_AUTH_SUCCESS';
const ON_REQUEST_RESEND_EMAIL = 'ON_REQUEST_RESEND_EMAIL';
const ON_REQUEST_RESEND_EMAIL_SUCCESS = 'ON_REQUEST_RESEND_EMAIL_SUCCESS';
const ON_REQUEST_RESEND_EMAIL_FAILURE = 'ON_REQUEST_RESEND_EMAIL_FAILURE';
const ON_LOGOUT = 'ON_LOGOUT';
const ON_LOGOUT_SUCCESS = 'ON_LOGOUT_SUCCESS';
const ON_LOGOUT_FAILURE = 'ON_LOGOUT_FAILURE';

const ON_REQUEST_HOME = 'ON_REQUEST_HOME';
const ON_REQUEST_HOME_SUCCESS = 'ON_REQUEST_HOME_SUCCESS';
const ON_REQUEST_HOME_FAILURE = 'ON_REQUEST_HOME_FAILURE';

const ON_REQUEST_KYC_STATUS = 'ON_REQUEST_KYC_STATUS';
const ON_REQUEST_KYC_STATUS_SUCCESS = 'ON_REQUEST_KYC_STATUS_SUCCESS';
const ON_REQUEST_KYC_STATUS_FAILURE = 'ON_REQUEST_KYC_STATUS_FAILURE';

const ON_REQUEST_PIN_DATA = 'ON_REQUEST_PIN_DATA';
const ON_REQUEST_PIN_DATA_FAILURE = 'ON_REQUEST_PIN_DATA_FAILURE';
const ON_REQUEST_PIN_DATA_SUCCESS = 'ON_REQUEST_PIN_DATA_SUCCESS';

function onLogout() {
  return {
    type: ON_LOGOUT,
  };
}

function onLogoutSuccess(payload) {
  return {
    type: ON_LOGOUT_SUCCESS,
    payload,
  };
}

function onLogoutFailure(payload) {
  return {
    type: ON_LOGOUT_FAILURE,
    payload,
  };
}

export const onDoLogout = (payload) => (dispatch) => {
  Fetch.post(`${V5}logout/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onLogoutSuccess(resp.json));
      } else {
        dispatch(onLogoutFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onLogoutFailure(error.message));
    })
    .finally(() => {
      dispatch(onLogout());
      clearSession();
    });
};

function onRequestAuth() {
  return {
    type: ON_REQUEST_AUTH,
  };
}

function onRequestAuthSuccess(payload) {
  return {
    type: ON_REQUEST_AUTH_SUCCESS,
    payload,
  };
}

function onRequestAuthFailure(payload) {
  return {
    type: ON_REQUEST_AUTH_FAILURE,
    payload,
  };
}

export const onDoRequestAuth = () => (dispatch) => {
  dispatch(onRequestAuth());
  Fetch.get(`${V3}users/me/`, true)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestAuthSuccess(resp.json));
      } else {
        dispatch(onRequestAuthFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestAuthFailure(error.message));
    });
};

// ----------------------------------------------------------

function onRequestPinData() {
  return {
    type: ON_REQUEST_PIN_DATA,
  };
}

function onRequestPinDataSuccess(payload) {
  return {
    type: ON_REQUEST_PIN_DATA_SUCCESS,
    payload,
  };
}

function onRequestPinDataFailure(payload) {
  return {
    type: ON_REQUEST_PIN_DATA_FAILURE,
    payload,
  };
}

export const onDoRequestPinData = () => (dispatch) => {
  dispatch(onRequestPinData());
  Fetch.get(`${V3}users/me/pin/get-pin-data/`, true)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestPinDataSuccess(resp.json.result));
      } else {
        dispatch(onRequestPinDataFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestPinDataFailure(error.message));
    });
};

// ----------------------------------------------------------
function onRequestHome() {
  return {
    type: ON_REQUEST_HOME,
  };
}

function onRequestHomeSuccess(payload) {
  return {
    type: ON_REQUEST_HOME_SUCCESS,
    payload,
  };
}

function onRequestHomeFailure(payload) {
  return {
    type: ON_REQUEST_HOME_FAILURE,
    payload,
  };
}

export const onDoRequestHome = () => (dispatch) => {
  dispatch(onRequestHome());
  Fetch.get(`${V1}home/`, false)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestHomeSuccess(resp.json));
      } else {
        dispatch(onRequestHomeFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestHomeFailure(error.message));
    });
};

function onRequestKycStatus() {
  return {
    type: ON_REQUEST_KYC_STATUS,
  };
}

function onRequestKycStatusSuccess(payload) {
  return {
    type: ON_REQUEST_KYC_STATUS_SUCCESS,
    payload,
  };
}

function onRequestKycStatusFailure(payload) {
  return {
    type: ON_REQUEST_KYC_STATUS_FAILURE,
    payload,
  };
}

export const onDoRequestKycStatus = () => (dispatch) => {
  dispatch(onRequestKycStatus());
  Fetch.get(`${V1}home/kyc/status/?include_coin=true`, false)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestKycStatusSuccess(resp.json));
      } else {
        dispatch(onRequestKycStatusFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestKycStatusFailure(error.message));
    });
};

// -----------------------------------------------------------

function onRequestSendEmail() {
  return {
    type: ON_REQUEST_RESEND_EMAIL,
  };
}

function onRequestSendEmailSuccess(payload) {
  return {
    type: ON_REQUEST_RESEND_EMAIL_SUCCESS,
    payload,
  };
}

function onRequestSendEmailFailure(payload) {
  return {
    type: ON_REQUEST_RESEND_EMAIL_FAILURE,
    payload,
  };
}

export const onDoRequestResendEmail = (payload) => (dispatch) => {
  dispatch(onRequestSendEmail());
  Fetch.post(`${V2}resend-verification-code/`, payload)
    .then((resp) => {
      dispatch(onRequestSendEmailSuccess(resp.json.detail));
    })
    .catch((error) => {
      dispatch(onRequestSendEmailFailure(error.message));
    });
};

const ON_REQUEST_USER_MF_PORTFOLIO = 'ON_REQUEST_USER_MF_PORTFOLIO';
const ON_REQUEST_USER_MF_PORTFOLIO_SUCCESS = 'ON_REQUEST_USER_MF_PORTFOLIO_SUCCESS';
const ON_REQUEST_USER_MF_PORTFOLIO_FAILURE = 'ON_REQUEST_USER_MF_PORTFOLIO_FAILURE';

function onRequestUserMfPortfolio() {
  return {
    type: ON_REQUEST_USER_MF_PORTFOLIO,
  };
}

function onRequestUserMfPortfolioSuccess(payload) {
  return {
    type: ON_REQUEST_USER_MF_PORTFOLIO_SUCCESS,
    payload,
  };
}

function onRequestUserMfPortfolioFailure(payload) {
  return {
    type: ON_REQUEST_USER_MF_PORTFOLIO_FAILURE,
    payload,
  };
}

export const onDoRequestUserMfPortfolio = () => (dispatch) => {
  dispatch(onRequestUserMfPortfolio());
  Fetch.get(`${V3}users/theme-funds/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestUserMfPortfolioSuccess(resp.json));
      } else {
        dispatch(onRequestUserMfPortfolioFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestUserMfPortfolioFailure(error.message));
    });
};

const ON_REQUEST_FORGET_PIN = 'ON_REQUEST_FORGET_PIN';
const ON_REQUEST_FORGET_PIN_FAILURE = 'ON_REQUEST_FORGET_PIN_FAILURE';
const ON_REQUEST_FORGET_PIN_SUCCESS = 'ON_REQUEST_FORGET_PIN_SUCCESS';
function onRequestForgetPin() {
  return {
    type: ON_REQUEST_FORGET_PIN,
  };
}
function onRequestForgetPinSuccess(payload) {
  return {
    type: ON_REQUEST_FORGET_PIN_SUCCESS,
    payload,
  };
}
function onRequestForgetPinFailure(payload) {
  return {
    type: ON_REQUEST_FORGET_PIN_FAILURE,
    payload,
  };
}
export const onDoRequestResetForgetPin = () => (dispatch) => {
  dispatch(onRequestForgetPinSuccess(null));
};
export const onDoRequestForgetPin = () => (dispatch) => {
  dispatch(onRequestForgetPin());
  Fetch.post(`${V1}users/me/pin/forget/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestForgetPinSuccess(resp.json));
      } else {
        dispatch(onRequestForgetPinFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestForgetPinFailure(error.message));
    });
};

const ON_REQUEST_VALIDATE_PIN = 'ON_REQUEST_VALIDATE_PIN';
const ON_REQUEST_VALIDATE_PIN_FAILURE = 'ON_REQUEST_VALIDATE_PIN_FAILURE';
const ON_REQUEST_VALIDATE_PIN_SUCCESS = 'ON_REQUEST_VALIDATE_PIN_SUCCESS';
const RESET_VALIDATE_PIN_DATA = 'RESET_VALIDATE_PIN_DATA';

function onRequestValidatePin() {
  return {
    type: ON_REQUEST_VALIDATE_PIN,
  };
}
function onRequestValidatePinSuccess(payload) {
  return {
    type: ON_REQUEST_VALIDATE_PIN_SUCCESS,
    payload,
  };
}
function onRequestValidatePinFailure(payload) {
  return {
    type: ON_REQUEST_VALIDATE_PIN_FAILURE,
    payload,
  };
}
export const onDoRequestResetValidatePin = () => (dispatch) => {
  dispatch(onRequestValidatePinSuccess(null));
};
export const onDoRequestValidatePin = (pin) => (dispatch) => {
  dispatch(onRequestValidatePin());
  Fetch.post(`${V3}users/me/pin/validate/`, { pin_code: pin }, false, true)
    .then((resp) => {
      if (resp.json.result.valid === true) {
        dispatch(onRequestValidatePinSuccess(resp.json));
      } else {
        dispatch(onRequestValidatePinFailure(resp.json.err_message));
      }
    })
    .catch((error) => {
      dispatch(onRequestValidatePinFailure(error.message));
    });
};

export function onDoResetValidatePinData() {
  return {
    type: RESET_VALIDATE_PIN_DATA,
  };
}

// NOTIFICATION TOKEN

const ON_SEND_NOTIFICATION_TOKEN = 'ON_SEND_NOTIFICATION_TOKEN';
const ON_SEND_NOTIFICATION_TOKEN_SUCCESS = 'ON_SEND_NOTIFICATION_TOKEN_SUCCESS';
const ON_SEND_NOTIFICATION_TOKEN_FAILURE = 'ON_SEND_NOTIFICATION_TOKEN_FAILURE';

function onSendNotificationToken() {
  return {
    type: ON_SEND_NOTIFICATION_TOKEN,
  };
}
function onSendNotificationTokenSuccess(payload) {
  return {
    type: ON_SEND_NOTIFICATION_TOKEN_SUCCESS,
    payload,
  };
}
function onSendNotificationTokenFailure(payload) {
  return {
    type: ON_SEND_NOTIFICATION_TOKEN_FAILURE,
    payload,
  };
}
export const onDoSendNotificationToken = (payload) => (dispatch) => {
  dispatch(onSendNotificationToken());
  Fetch.post(`${V1}users/notification/channel/`, payload, false, true)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onSendNotificationTokenSuccess(resp.json));
      } else {
        dispatch(onSendNotificationTokenFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onSendNotificationTokenFailure(error.message));
    });
};

const IS_INFLUENCER_BANNER_HIDDEN = 'IS_INFLUENCER_BANNER_HIDDEN';

export function onSetIsInfluencerBannerHidden(payload) {
  return {
    type: IS_INFLUENCER_BANNER_HIDDEN,
    payload,
  };
}

const INITIAL_STATE = {
  userLoading: false,
  userData: null,
  userError: null,

  pinStatus: null,
  pinStatusLoading: false,
  pinStatusError: null,

  homeLoading: false,
  homeData: null,
  homeError: null,

  kycStatusLoading: false,
  kycStatusData: null,
  kycStatusError: null,

  userMfPorfolioLoading: false,
  userMfPorfolioData: null,
  userMfPorfolioError: null,

  resendEmailLoading: false,
  successResendEmail: null,
  failureResendEmail: null,

  forgetPinLoading: false,
  forgetPinData: null,
  forgetPinError: null,

  validatePinLoading: false,
  validatePinData: null,
  validatePinError: null,

  sendFCMTokenLoading: false,
  sendFCMTokenSuccess: null,
  sendFCMTokenError: null,

  logoutLoading: false,
  logoutSuccess: null,
  logoutError: null,

  isInfluencerBannerHidden: false,
};

const auth = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_RESEND_EMAIL:
      return {
        ...state,
        resendEmailLoading: true,
        successResendEmail: null,
        failureResendEmail: null,
      };
    case ON_REQUEST_RESEND_EMAIL_SUCCESS:
      return {
        ...state,
        resendEmailLoading: false,
        successResendEmail: action.payload,
        failureResendEmail: null,
      };
    case 'ON_REQUEST_RESEND_EMAIL_FAILURE':
      return {
        ...state,
        resendEmailLoading: false,
        successResendEmail: null,
        failureResendEmail: action.payload,
      };
    case ON_REQUEST_AUTH:
      return {
        ...state,
        userLoading: true,
        userData: null,
        userError: null,
      };
    case ON_REQUEST_AUTH_SUCCESS:
      return {
        ...state,
        userLoading: false,
        userData: action.payload,
        userError: null,
      };
    case ON_REQUEST_AUTH_FAILURE:
      return {
        ...state,
        userLoading: false,
        userData: null,
        userError: action.payload,
      };
    // ---------------------------------------------
    case ON_REQUEST_PIN_DATA:
      return {
        ...state,
        pinDataLoading: true,
        pinDataError: null,
        pinData: null,
      };
    case ON_REQUEST_PIN_DATA_SUCCESS:
      return {
        ...state,
        pinDataLoading: false,
        pinDataError: null,
        pinData: action.payload,
      };
    case ON_REQUEST_PIN_DATA_FAILURE:
      return {
        ...state,
        pinDataLoading: false,
        pinDataError: action.payload,
        pinData: null,
      };
    // ---------------------------------------------
    case ON_REQUEST_HOME:
      return {
        ...state,
        homeLoading: true,
        homeData: null,
        homeError: null,
      };
    case ON_REQUEST_HOME_SUCCESS:
      return {
        ...state,
        homeLoading: false,
        homeData: action.payload,
        homeError: null,
      };
    case ON_REQUEST_HOME_FAILURE:
      return {
        ...state,
        homeLoading: false,
        homeData: null,
        homeError: action.payload,
      };

    case ON_REQUEST_KYC_STATUS:
      return {
        ...state,
        kycStatusLoading: true,
        kycStatusData: null,
        kycStatusError: null,
      };
    case ON_REQUEST_KYC_STATUS_SUCCESS:
      return {
        ...state,
        kycStatusLoading: false,
        kycStatusData: action.payload,
        kycStatusError: null,
      };
    case ON_REQUEST_KYC_STATUS_FAILURE:
      return {
        ...state,
        kycStatusLoading: false,
        kycStatusData: null,
        kycStatusError: action.payload,
      };
    // ---------------------------------------------

    case ON_REQUEST_USER_MF_PORTFOLIO:
      return {
        ...state,
        userMfPorfolioLoading: true,
        userMfPorfolioData: null,
        userMfPorfolioError: null,
      };
    case ON_REQUEST_USER_MF_PORTFOLIO_SUCCESS:
      return {
        ...state,
        userMfPorfolioLoading: false,
        userMfPorfolioData: action.payload,
        userMfPorfolioError: null,
      };
    case ON_REQUEST_USER_MF_PORTFOLIO_FAILURE:
      return {
        ...state,
        userMfPorfolioLoading: false,
        userMfPorfolioData: null,
        userMfPorfolioError: action.payload,
      };

    case ON_REQUEST_FORGET_PIN:
      return {
        ...state,
        forgetPinLoading: true,
        forgetPinData: null,
        forgetPinError: null,
      };
    case ON_REQUEST_FORGET_PIN_SUCCESS:
      return {
        ...state,
        forgetPinLoading: false,
        forgetPinData: action.payload,
        forgetPinError: null,
      };
    case ON_REQUEST_FORGET_PIN_FAILURE:
      return {
        ...state,
        forgetPinLoading: false,
        forgetPinData: null,
        forgetPinError: action.payload,
      };

    case ON_REQUEST_VALIDATE_PIN:
      return {
        ...state,
        validatePinLoading: true,
        validatePinData: null,
        validatePinError: null,
      };
    case ON_REQUEST_VALIDATE_PIN_SUCCESS:
      return {
        ...state,
        validatePinLoading: false,
        validatePinData: action.payload,
        validatePinError: null,
      };
    case ON_REQUEST_VALIDATE_PIN_FAILURE:
      return {
        ...state,
        validatePinLoading: false,
        validatePinData: null,
        validatePinError: action.payload,
      };

    case ON_SEND_NOTIFICATION_TOKEN:
      return {
        ...state,
        sendFCMTokenLoading: true,
        sendFCMTokenSuccess: null,
        sendFCMTokenError: null,
      };
    case ON_SEND_NOTIFICATION_TOKEN_SUCCESS:
      return {
        ...state,
        sendFCMTokenLoading: false,
        sendFCMTokenSuccess: action.payload,
        sendFCMTokenError: null,
      };
    case ON_SEND_NOTIFICATION_TOKEN_FAILURE:
      return {
        ...state,
        sendFCMTokenLoading: false,
        sendFCMTokenSuccess: null,
        sendFCMTokenError: action.payload,
      };

    case ON_LOGOUT:
      return {
        ...state,
        logoutLoading: true,
        logoutSuccess: null,
        logoutError: action.payload,
      };
    case ON_LOGOUT_SUCCESS:
      return {
        ...state,
        logoutLoading: false,
        logoutSuccess: action.payload,
        logoutError: null,
      };
    case ON_LOGOUT_FAILURE:
      return {
        ...state,
        logoutLoading: false,
        logoutSuccess: null,
        logoutError: action.payload,
      };
    case RESET_VALIDATE_PIN_DATA:
      return {
        ...state,
        validatePinData: null,
      };
    case IS_INFLUENCER_BANNER_HIDDEN:
      return {
        ...state,
        isInfluencerBannerHidden: action.payload,
      };
    default:
      return state;
  }
};

export default auth;
